<template>
  <div :class="['weight-bold text-red padding-y-15', font40]">{{title}}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  computed: {
    font40: function () {
      return this.$root.isMobile ? 'font-32' : this.$root.isEnglish ? 'font-40' : 'font-32'
    }
  }
}
</script>

<style scoped>
</style>
